import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";

import styled from "styled-components";
// @ts-ignore
import { Link } from "react-router-dom";

import BpsLegend from "./BpsLegend";
import BpsEvolutionChart from "./BpsEvolutionChart";
import Constants from "../../../data/Constants";
import { GlobalDataContext } from "../../../contexts/GlobalDataContext";

const legendItems = [
  { regionCode: 'REM',
    borderColor: '#DA7F52',
    fillColor: '#D5987D' },
  { regionCode: 'BRICS',
    borderColor: '#4E8F7E',
    fillColor: '#8EC1B6' },
  { regionCode: 'RDM',
    borderColor: '#A44FD1',
    fillColor: '#B99CC4' },
  { regionCode: 'G7',
    borderColor: '#1E6BD1',
    fillColor: '#779DCF' },
];

const Wrapper = styled.div`
  background-color: #737373;
  min-height: 100%;
  padding-left: 10%;
  padding-right: 10%;
  padding-top: 0.8em;

  .bps-economic-region__navbar {
    align-items: center;
    color: white;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    & h3 {
      color: white;
      font-family: Mapfre-Bold;
      font-size: 1.41625rem;
    }

    & button {
      align-items: center;
      background: none;
      border: none;
      color: white;
      display: flex;
      font-family: Mapfre-Medium;
      font-size: 1rem;
      height: fit-content;

      &:before {
        content: ' ';
        border-right: 0.8em solid white;
        border-top: 0.4em solid transparent;
        border-bottom: 0.4em solid transparent;
        display: inline-block;
        margin-right: 0.4em;
      }
    }
  }
`;

const BpsEconomicRegion = () => {
  const { t } = useTranslation();

  const [selectedRegion, setSelectedRegion] = useState<string>();

  // @ts-ignore
  const { allDataLoaded, last10YearReports } = useContext(GlobalDataContext);
  const [ records, setRecords ] = useState<any>();

  useEffect(() => {
    if (allDataLoaded) {
      const records = Object
        .values(last10YearReports)
        .flatMap((report: any) => (
          report.region_records.map((record: any) => (
            { year: record.report_year, region: record.region_code, bps: parseFloat(record.bps), is_life: record.is_life }
          ))
        ));

      setRecords(records);
    }
  }, [allDataLoaded]);

  return (
    <Wrapper>
      <div className='bps-economic-region__navbar'>
        <h3>{ t('bps.title') }</h3>
        <Link to={ Constants.routes.bps }>
          <button>Back</button>
        </Link>
      </div>
      { records &&
          <BpsEvolutionChart
            branch={ t('lifeSelector.life') }
            records={ records.filter((record: any) => record.is_life) }
            selectedRegion={ selectedRegion }
            boldTitle={ t('bpsMarket.evolutionTitle') }
            lightTitle={ t('bpsMarket.evolutionDescription') }
            isStacked={ true }
          />
      }
      <BpsLegend
        items={ legendItems }
        selectedRegion={ selectedRegion }
        onRegionSelected={ setSelectedRegion }
      />
      { records &&
          <BpsEvolutionChart
            branch={ t('lifeSelector.noLife') }
            records={ records.filter((record: any) => !record.is_life) }
            selectedRegion={ selectedRegion }
            boldTitle={ t('bpsMarket.evolutionTitle') }
            lightTitle={ t('bpsMarket.evolutionDescription') }
            isStacked={ true }
          />
      }
    </Wrapper>
  )
};

export default BpsEconomicRegion;
